import { baseApi } from './baseApi';

export const inventoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStockLevels: builder.query({
      query: (params) => ({
        url: '/inventory/levels',
        params,
      }),
      providesTags: ['Inventory'],
    }),
    adjustStock: builder.mutation({
      query: (data) => ({
        url: '/inventory/adjust',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Inventory'],
    }),
    getStockMovements: builder.query({
      query: (params) => ({
        url: '/inventory/movements',
        params,
      }),
      providesTags: ['Inventory'],
    }),
    getLocations: builder.query({
      query: () => '/inventory/locations',
      providesTags: ['Inventory'],
    }),
    createLocation: builder.mutation({
      query: (data) => ({
        url: '/inventory/locations',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Inventory'],
    }),
  }),
});

export const {
  useGetStockLevelsQuery,
  useAdjustStockMutation,
  useGetStockMovementsQuery,
  useGetLocationsQuery,
  useCreateLocationMutation,
} = inventoryApi;
